export const TABS = [
  { label: 'Recommended', value: 'recommended' },
  { label: 'My Content', value: 'my_content' },
  { label: 'News Feed', value: 'news_feed' },
  { label: 'Branded', value: 'branded' },
];
